import React, { createContext, useState } from "react";

const StepContext = createContext();

export function StepProvider({ children, steps }) {
    const [activeStep, setActiveStep] = useState(0);
    const isActiveStep = (index) => activeStep === index;
    const isLastStep = () => activeStep === steps.length - 1;
    const isFirstStep = () => activeStep === 0;
    const onNext = () => {
        setActiveStep(activeStep + 1);
    };
    const onPrevious = () => {
        setActiveStep(activeStep - 1);
    }

    const currentStep = steps[activeStep];

    return (
        <StepContext.Provider value={{
            isActiveStep,
            isFirstStep,
            isLastStep,
            activeStep,
            setActiveStep,
            onNext,
            onPrevious,
            steps,
            currentStep
        }}>
            {children}
        </StepContext.Provider>
    );
}

export default StepContext;



